import * as THREE from 'three';
import IMOG from '~/lib/imog';
import loadTexture from '~/lib/three/loadTexture';

import Sky from './Sky';
import Floor from './Floor';
import Spider from './Spider';

const v = new THREE.Vector3();
const v2 = new THREE.Vector3();

export default IMOG.Component('Object', {
  options: {
    addTo: null,
  },

  props() {
    return {
      active: false,
    };
  },

  async setup({ options }) {
    this.solids = [];
    IMOG.inject('solids', this.solids);

    // this.geometry = new THREE.BoxBufferGeometry(1, 1, 1);
    // this.material = new THREE.MeshStandardMaterial({ color: 0xeeeeee });
    // this.mesh = new THREE.Mesh(this.geometry, this.material);
    // this.mesh.position.y = 0.6;
    // this.mesh.castShadow = true;

    // this.glow = new THREE.Mesh(
    //   this.geometry,
    //   new THREE.MeshBasicMaterial({
    //     color: '#ffffff',
    //     // transparent: true,
    //     // opacity: 0.5,
    //   })
    // );
    // this.mesh.add(this.glow);
    // this.glow.layers.set(1);

    this.sky = new Sky({ options: { addTo: options.addTo } });
    this.floor = new Floor({ options: { addTo: options.addTo } });

    this.ambientLight = new THREE.AmbientLight(0x606575, 0.4);

    this.light = new THREE.DirectionalLight(0xffffff, 1);
    this.light.position.set(-0.8, 0.8, -0.5);
    this.light.castShadow = true;
    this.light.shadow.camera.near = 0.1;
    this.light.shadow.camera.far = 10;
    this.light.shadow.camera.top = 2;
    this.light.shadow.camera.bottom = -2;
    this.light.shadow.camera.left = -2;
    this.light.shadow.camera.right = 2;
    this.light.shadow.mapSize.width = 256 * 4;
    this.light.shadow.mapSize.height = 256 * 4;
    this.light.shadow.bias = -0.01;
    // this.light.shadow.radius = 2;

    if (options.addTo) {
      // options.addTo.add(this.mesh);
      options.addTo.add(this.ambientLight);
      options.addTo.add(this.light);
      options.addTo.add(this.light.target);
    }

    this.spider = new Spider({
      options: {
        addTo: options.addTo,
      },

      props: {
        active: (props) => this.props.active,
      },
    });

    await Promise.all([this.floor.loaded(), this.spider.loaded()]);

    this.props.active = true;
  },

  hooks: {
    'while:active'() {
      if (this.$spider) {
        this.$spider.bones.Base.getWorldPosition(v);
        this.light.target.position.copy(v);
        v2.set(-0.8, 0.8, -0.5);
        this.light.position.copy(v).add(v2);
      }
      // this.mesh.rotation.y += 0.01;
    },
  },
});
